import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  Typography
} from '@mui/material'

interface AspectRatioOption {
  value: string
  label: string
  description: string
}

const aspectRatios: AspectRatioOption[] = [
  { value: 'none', label: 'Original', description: 'Keep original dimensions' },
  { value: '16:9', label: '16:9', description: 'Landscape (HD video)' },
  { value: '9:16', label: '9:16', description: 'Portrait (Mobile video)' },
  { value: '4:3', label: '4:3', description: 'Classic photo' },
  { value: '3:4', label: '3:4', description: 'Portrait photo' },
  { value: '3:2', label: '3:2', description: 'DSLR standard' },
  { value: '2:3', label: '2:3', description: 'Portrait DSLR' },
  { value: '1:1', label: '1:1', description: 'Square (Instagram)' }
]

interface AspectRatioSelectorProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

const AspectRatioSelector: React.FC<AspectRatioSelectorProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  const selectedOption = aspectRatios.find(r => r.value === value)

  return (
    <Box>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel>Proporcje obrazu</InputLabel>
        <Select
          value={value}
          label="Proporcje obrazu"
          onChange={handleChange}
        >
          {aspectRatios.map((ratio) => (
            <MenuItem key={ratio.value} value={ratio.value}>
              <Box>
                <Typography variant="body1">{ratio.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {ratio.description}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectedOption && selectedOption.value !== 'none' && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          Obraz zostanie przycięty do wybranych proporcji
        </Typography>
      )}
    </Box>
  )
}

export default AspectRatioSelector
